<template lang="html">
  <div class="contract-setup-component">
    <v-container>
    <v-data-table
      :headers="headers"
      :items="contract_configs"
      :items-per-page="10"
      class="elevation-2"
      @click:row="selectedDatas($event)"
    ></v-data-table>
    <br>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="from_date"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          label="Érvényesség kezdete"
          append-icon="date_range"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="to_date"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          label="Érvényesség vége"
          append-icon="date_range"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="selected_file"
          :items="files"
          outlined
          label="Fájlnév"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="selected_category"
          :items="categories"
          item-text="contract_name"
          item-value="nkh_course_type_id"
          outlined
          label="Kategória"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="price_date_x"
          label="Ártájékoztató dátum - X"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="price_date_y"
          label="Ártájékoztató dátum - Y"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="pages"
          label="Ártájékoztató oldalszám"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="evjf_date_x"
          label="EVJF dátum - X"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="evjf_date_y"
          label="EVJF dátum - Y"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="stamp_size"
          label="Bélyeg méret"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="stamp_x"
          label="Bélyegző - X"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="stamp_y"
          label="Bélyegző - Y"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-checkbox
          v-model="noCourse"
          label="Átjelentkező"
          value="WithoutCourse"
        ></v-checkbox>
      </v-col>
    </v-row>
    <br>
    <v-row justify="center">
      <v-col cols="6" md="2">
      <v-btn rounded color="primary" @click="newFile()">
        Új
        <v-icon right dark>add_circle_outline</v-icon>
      </v-btn>
      </v-col>
      <v-col cols="6" md="2">
      <v-btn rounded class="white--text" color="red" @click="saveConfig()">
        mentés
        <v-icon right color="white">save</v-icon>
      </v-btn>
      </v-col>
      <v-col cols="12" md="2">
      <v-btn outlined rounded color="red" @click="saveAsConfig()">
        mentés másként
        <v-icon right dark>content_copy</v-icon>
      </v-btn>
      </v-col>
    </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar"
    >
      {{ response_text }}
        <v-btn
          color="pink"
          text
          @click="snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        contract_configs: [],
        headers: [
          { text: 'Kategória', value: 'category_name' },
          { text: 'Kategória ID', value: 'category' },
          { text: 'Érvényesség kezdete', value: 'from_date' },
          { text: 'Érvényesség vége', value: 'to_date' },
          { text: 'Fájlnév', value: 'file' },
        ],
        from_date: '',
        to_date: '',
        files: [],
        selected_file: '',
        categories: [],
        selected_category: '',
        price_date_x: '',
        price_date_y: '',
        pages: '',
        evjf_date_x: '',
        evjf_date_y: '',
        stamp_size: '',
        stamp_x: '',
        stamp_y: '',
        selected_id: '',
        response_text: '',
        snackbar: false,
        noCourse: '',
      }
    },
    methods: {
      getConfig: async function() {
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_config', {
          token: this.token
        }).then((response) => {
          this.contract_configs = response.data['config']
          this.files = response.data['files']
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveConfig: async function() {
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_save', {
          token: this.token,
          selected_id: this.selected_id,
          from_date: this.from_date,
          to_date: this.to_date,
          selected_file: this.selected_file,
          selected_category: this.selected_category,
          price_date_x: this.price_date_x,
          price_date_y: this.price_date_y,
          pages: this.pages,
          evjf_date_x: this.evjf_date_x,
          evjf_date_y: this.evjf_date_y,
          stamp_size: this.stamp_size,
          stamp_x: this.stamp_x,
          stamp_y: this.stamp_y,
          no_course: this.noCourse
        }).then((response) => {
          this.response_text = response.data['message']
          this.selected_id = response.data['id']
          this.snackbar = true
          this.getConfig()
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveAsConfig: async function() {
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_save', {
          token: this.token,
          selected_id: null,
          from_date: this.from_date,
          to_date: this.to_date,
          selected_file: this.selected_file,
          selected_category: this.selected_category,
          price_date_x: this.price_date_x,
          price_date_y: this.price_date_y,
          pages: this.pages,
          evjf_date_x: this.evjf_date_x,
          evjf_date_y: this.evjf_date_y,
          stamp_size: this.stamp_size,
          stamp_x: this.stamp_x,
          stamp_y: this.stamp_y,
          no_course: this.noCourse
        }).then((response) => {
          this.response_text = response.data['message']
          this.selected_id = response.data['id']
          this.snackbar = true
          this.getConfig()
        }, (error) => {
          this.error_text = error.data
        })
      },
      selectedDatas(value) {
        this.selected_id = value.id
        this.from_date = value.from_date
        this.to_date = value.to_date
        this.selected_file = value.file
        this.selected_category = parseInt(value.category)
        this.price_date_x = value.price_date_x
        this.price_date_y = value.price_date_y
        this.pages = value.pages
        this.evjf_date_x = value.evjf_date_x
        this.evjf_date_y = value.evjf_date_y
        this.stamp_size = value.stamp_size
        this.stamp_x = value.stamp_x
        this.stamp_y = value.stamp_y
        this.noCourse = value.no_course
      },
      newFile() {
        this.selected_id = null
        this.from_date = null
        this.to_date = null
        this.selected_file = null
        this.selected_category = null
        this.price_date_x = null
        this.price_date_y = null
        this.pages = null
        this.evjf_date_x = null
        this.evjf_date_y = null
        this.stamp_size = null
        this.stamp_x = null
        this.stamp_y = null
        this.noCourse = null
      },
      getCategories: async function() {
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/category_list', {
          token: this.token
        }).then((response) => {
          this.categories = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      this.getConfig()
      this.getCategories()
    }
  }
</script>

<style lang="css">
</style>
